import(/* webpackMode: "eager", webpackExports: ["SalesPageClient"] */ "/app/src/app/[locale]/(default)/sales/components/SalesPageClient.tsx");
